import React from 'react';
import cn from 'classnames';
import { Link, Title } from '@landing/ui';
import { Button, Container } from 'components/UI';

import * as styles from './CallToAction.module.scss';

export default function CallToAction({
  title,
  subtitle,
  titleTag = 'p',
  titleSize = 'h2',
  button,
  link,
  background = 'lightGray',
  theme,
  padding,
}) {
  return (
    <Container
      className={cn(styles.container, styles[theme])}
      background={background}
      padding={padding}
    >
      <div className={styles.wrapper}>
        <div className={styles.titleRow}>
          <Title
            tag={titleTag}
            size={titleSize}
            color={background === 'darkPrimary' ? 'white' : 'black'}
          >
            {title}
          </Title>
        </div>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        <div className={styles.buttonRow}>
          {button && (
            <Button className={styles.button} {...button} target="_self">
              {button.text}
            </Button>
          )}
          {link && (
            <Link className={styles.link} href={link.href} target={link?.target} rel={null}>
              {link.name}
            </Link>
          )}
        </div>
      </div>
    </Container>
  );
}
